<template>
	<modal id="steps" ref="steps" :closeProp="close" :title="title" large>
		<form method="POST" :action="action">
			<form-input type="hidden" name="_token" :value="csrf" />
			<form-input type="hidden" name="source_id" :value="source.toString()" />
			<form-input type="hidden" name="thx_page" :value="step.thx_page" />
			<form-input type="hidden" name="_method" :value="method" />

			<div class="row">
				<div class="col-md-6">
					<form-select
						label="Tipo Step"
						name="step_content_id"
						id="stepContent"
						:options="types"
						:value="content_id"
						@change="changeCustomForm"
					></form-select>
				</div>
				<div class="col-md-6">
					<form-input
						name="weight"
						type="number"
						id="stepWeight"
						placeholder="Inserisci il peso dello Step"
						label="Peso"
						:value="step.weight.toString()"
					></form-input>
				</div>
			</div>

			<div class="row">
				<div class="col-md-6">
					<form-input
						name="title"
						type="text"
						id="stepTitle"
						placeholder="Inserisci il Titolo dello Step"
						label="Titolo"
						:value="step.title"
					></form-input>
				</div>
				<div class="col-md-6">
					<form-input
						:required="false"
						name="sub_title"
						type="text"
						id="stepSubTitle"
						placeholder="Inserisci il Sottotitolo dello Step"
						label="Sottotitolo"
						:value="step.sub_title"
					></form-input>
				</div>
			</div>

			<div class="row">
				<div class="col-md-6">
					<form-segment
						label="Secure Text"
						name="secure_text"
						id="stepSecureText"
						:options="[
							{ label: 'Si', value: '1' },
							{ label: 'No', value: '0' },
						]"
						:value="step.secure_text.toString()"
					></form-segment>
				</div>
				<div class="col-md-6">
					<form-segment
						label="Salva Donatore"
						name="save_data"
						id="stepSaveDonor"
						:options="[
							{ label: 'Si', value: '1' },
							{ label: 'No', value: '0' },
						]"
						:value="step.save_data.toString()"
					></form-segment>
				</div>
			</div>

			<div class="row">
				<div class="col-md-6">
					<form-input
						name="redirect_url"
						type="text"
						id="stepRedirectUrl"
						placeholder="Inserisci Redirect URL"
						label="Redirect URL (5 sec.)"
						:value="step.redirect_url"
						:required="false"
					></form-input>
				</div>
			</div>

			<div class="row">
				<div class="col-md-6">
					<form-segment
						label="Torna Indietro"
						name="hide_back_btn"
						id="stepHideBackBtn"
						:options="[
							{ label: 'Si', value: '0' },
							{ label: 'No', value: '1' },
						]"
						:value="step.hide_back_btn"
					></form-segment>
				</div>
				<div class="col-md-6">
					<form-input
						:required="false"
						name="button_text"
						type="text"
						id="stepButtonText"
						placeholder="Inserisci il Testo del Bottone"
						label="Testo Bottone"
						:value="step.button_text"
					></form-input>
				</div>
			</div>

			<div class="row">
				<div class="col-md-6">
					<label>Mostra Bottone Donatore Errato</label>
					<div
						class="radio-inputs"
						style="
							position: relative;
							display: flex;
							flex-wrap: wrap;
							border-radius: 4px;
							background-color: #dae0e5;
							box-sizing: border-box;
							box-shadow: 0 0 0px 1px rgba(0, 0, 0, 0.06);
							border: 2px solid #dae0e5;
							margin-bottom: 10px;
						"
					>
						<label class="radio">
							<input
								type="radio"
								v-model="step.show_wrong_donor_btn"
								name="show_wrong_donor_btn"
								value="1"
							/>
							<span class="name">Si</span>
						</label>
						<label class="radio">
							<input
								type="radio"
								v-model="step.show_wrong_donor_btn"
								name="show_wrong_donor_btn"
								value="0"
							/>
							<span class="name">No</span>
						</label>
					</div>
				</div>
				<div class="col-md-6">
					<form-input
						v-if="step.show_wrong_donor_btn == '1'"
						:required="false"
						name="wrong_donor_btn_text"
						type="text"
						id="stepWrongDonorBtnText"
						placeholder="Inserisci il Testo del Bottone"
						label="Testo Bottone Donatore Errato"
						:small="'Inserendo {$queryParam} (dove queryParam è il parametro nel URL) viene effettuato la sostituzione con il valore del parametro.'"
						:value="step.wrong_donor_btn_text"
					></form-input>
				</div>
			</div>

			<div class="row">
				<div class="col-md-6">
					<form-textarea
						:required="false"
						name="footer_text"
						id="footer_text"
						label="Footer"
						:value="step.footer_text"
						small="Inserendo '{fieldName}' (dove 'fieldName' è il nome del campo del form primario) viene effettuato la sostituzione con il nome del campo."
					></form-textarea>
				</div>
			</div>

			<div class="row">
				<div class="col-md-6">
					<form-textarea
						:required="false"
						name="gtm_formerror"
						id="gtm_formerror"
						label="GTM: Form Error"
						small="Inserire solo l'array della funzione. Inserendo '{fieldName}' viene effettuato la sostituzione con il nome del campo."
						:value="step.gtm_formerror"
					></form-textarea>
				</div>

				<div class="col-md-6">
					<label>Abilita Google analytics</label>
					<div
						class="radio-inputs"
						style="
							position: relative;
							display: flex;
							flex-wrap: wrap;
							border-radius: 4px;
							background-color: #dae0e5;
							box-sizing: border-box;
							box-shadow: 0 0 0px 1px rgba(0, 0, 0, 0.06);
							border: 2px solid #dae0e5;
							margin-bottom: 10px;
						"
					>
						<label class="radio">
							<input
								type="radio"
								v-model="step.enable_ga"
								name="enable_ga"
								value="1"
							/>
							<span class="name">Si</span>
						</label>
						<label class="radio">
							<input
								type="radio"
								v-model="step.enable_ga"
								name="enable_ga"
								value="0"
								v-on:change="set_event_null"
							/>
							<span class="name">No</span>
						</label>
					</div>

					<div v-if="step.enable_ga == '1'">
						<label>Tipo Evento</label>
						<div class="select-enable_ga">
							<select name="event_type" v-model="step.event_type">
								<option value="null" selected disabled>- Scegli l'evento-</option>

								<option
									v-for="event in ga_events"
									:value="event.value"
									:key="event.id"
								>
									{{ event.label }}
								</option>
							</select>
						</div>
					</div>

					<form-input
						v-if="step.enable_ga == '1'"
						name="form_name"
						type="text"
						id="stepformName"
						placeholder="Inserisci il formName"
						label="formName"
						:value="step.form_name"
					></form-input>
				</div>
			</div>

			<div class="row">
				<div class="col-md-6">
					<label>Condividi con WhatsApp</label>
					<div
						class="radio-inputs"
						style="
							position: relative;
							display: flex;
							flex-wrap: wrap;
							border-radius: 4px;
							background-color: #dae0e5;
							box-sizing: border-box;
							box-shadow: 0 0 0px 1px rgba(0, 0, 0, 0.06);
							border: 2px solid #dae0e5;
							margin-bottom: 10px;
						"
					>
						<label class="radio">
							<input
								type="radio"
								v-model="step.share_with_whatsapp"
								name="share_with_whatsapp"
								value="1"
							/>
							<span class="name">Si</span>
						</label>
						<label class="radio">
							<input
								type="radio"
								v-model="step.share_with_whatsapp"
								name="share_with_whatsapp"
								value="0"
							/>
							<span class="name">No</span>
						</label>
					</div>
				</div>
				<div class="col-md-6">
					<form-textarea
						v-if="step.share_with_whatsapp == '1'"
						name="share_with_whatsapp_text"
						id="stepShareWithWhatsAppText"
						placeholder="Inserisci il Testo da Condividere"
						label="Testo da Condividere"
						:value="step.share_with_whatsapp_text"
						:required="false"
					></form-textarea>
				</div>
			</div>

			<!-- <div class="row">
				<div class="col-md-6">
					<form-segment
						label="Attiva Google Analytics?"
						name="enable_ga"
						v-model="step.enable_ga"
						id="google_analytics"
						:options="[
							{ label: 'Si', value: '1' },
							{ label: 'No', value: '0' },
						]"
						:value="step.enable_ga"
					></form-segment>
				</div>
			</div> -->

			<btn submit type="success" :icon="['far', 'check']" title="Salva"></btn>
		</form>

		<br />
		<br />

		<div v-if="!!custom_form">
			<label>Elementi del Form</label>
			<datatable
				ref="formElementsTable"
				:cols="cols"
				:url="step.form_items_list_url"
				:create-url="step.form_items_create_url"
				:editable="true"
				:defs="[
					{
						index: 3,
						render: (item, row, meta) => $root.formatBoolTableCell(item, row, meta),
					},
					{
						index: 4,
						render: (item, row, meta) => $root.formatBoolTableCell(item, row, meta),
					},
				]"
				:border="true"
			>
			</datatable>
		</div>
	</modal>
</template>

<style>
/*.form-group {
	margin: 0;
}*/
/* .radio-inputs {
	position: relative;
	display: flex;
	flex-wrap: wrap;
	border-radius: 4px;
	background-color: #dae0e5;
	box-sizing: border-box;
	box-shadow: 0 0 0px 1px rgba(0, 0, 0, 0.06);
	border: 2px solid #dae0e5;
	margin-bottom: 10px;
} */

.radio-inputs .radio {
	flex: 1 1 auto;
	text-align: center;
	padding: 0;
}

.radio-inputs .radio input {
	display: none;
}

.radio-inputs .radio .name {
	font-size: 1rem;
	font-weight: 400;
	display: flex;
	cursor: pointer;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
	border: none;
	padding: 0.5rem 0;
	color: rgba(51, 65, 85, 1);
	transition: all 0.15s ease-in-out;
}

.radio-inputs .radio input:checked + .name {
	background-color: #fff;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

/********************* */
.checkbox-enable_ga {
	display: flex;
	margin-bottom: 10px;
}

.checkbox-enable_ga label {
	padding: 0;
	margin-left: 5px;
}

input[type='checkbox'] {
	width: 20px;
	height: 20px;
	padding: 14px 20px;
	border-radius: 4px;
	cursor: pointer;
}

select {
	width: 100%;
	border: 1px solid #eee;
	border-radius: 4px;
	font-size: 1rem;
	font-weight: 400;
	height: auto;
	line-height: normal;
	margin: 0;
	padding: 8px;
}
</style>

<script src="https://unpkg.com/vue@3.0.5"></script>
<script>
export default {
	data: () => ({
		step: {
			weight: 0,
			secure_text: '',
			save_data: '',
			hide_back_button: '',
			thx_page: 0,
			form_items_list_url: '',
			form_items_create_url: '',
			enable_ga: '0',
			event_type: null,
			form_name: '',
			share_with_whatsapp: '0',
			share_with_whatsapp_text: '',
			show_wrong_donor_btn: '0',
			wrong_donor_btn_text: '',
		},
		custom_form: false,
		showFirst: 1,
		key: '',
	}),
	props: {
		steps_content: {
			type: Array,
			required: true,
		},
		source: {
			type: Number,
			required: true,
		},
		cols: {
			type: Array,
			required: true,
		},
		ga_events: {
			type: Array,
			required: true,
		},
	},

	computed: {
		title: function () {
			return !!this.step.id ? 'Modifica Step' : 'Nuovo Step'
		},
		types: function () {
			return this.steps_content.map((cont) => ({
				label: cont.display_name,
				value: cont.id,
			}))
		},
		content_id: function () {
			return this.step.step_content_id
		},
		action: function () {
			return !!this.step.id ? '/steps/' + this.step.id : '/steps'
		},
		method: function () {
			return !!this.step.id ? 'PATCH' : 'POST'
		},
		csrf: function () {
			return document.querySelector('meta[name="csrf-token"]').getAttribute('content')
		},
	},
	methods: {
		close: function () {
			this.$refs.steps.close()
		},
		open: function (step, thx_page = false) {
			if (!!step.id) this.step = step
			else
				this.step = {
					weight: 0,
					secure_text: '',
					save_data: '',
					hide_back_button: '',
					thx_page: !!thx_page ? '1' : '0',
					form_items_list_url: '',
					form_items_create_url: '',
					enable_ga: 0,
					event_type: null,
					form_name: '',
					share_with_whatsapp: '0',
					share_with_whatsapp_text: '',
					show_wrong_donor_btn: '0',
					wrong_donor_btn_text: '',
				}

			this.changeCustomForm(this.content_id)

			this.$refs.steps.open()
		},
		changeCustomForm: function (value) {
			this.custom_form = value == 5 ? true : false
		},
		set_event_null() {
			this.step.event_type = null
		},
	},
}
</script>
